import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LabelContainer, LabelOptionalTag } from './styles/label.styled';
export const Label = ({ text, required, reference, children, colorContext = 'on-light', disabled, }) => {
    return (_jsxs(LabelContainer, { htmlFor: reference, id: `${reference}-label`, "$colorContext": colorContext, "$disabled": disabled, children: [text, !required && (_jsxs(_Fragment, { children: [' ', _jsx(LabelOptionalTag, { children: "(optioneel)" })] })), children] }));
};
